import React  from 'react'

import './Search.css'

import {compose, setDisplayName, withHandlers, withPropsOnChange, withStateHandlers} from "recompose";
import {connect} from "react-redux";
import {always, equals, ifElse} from "ramda";
import {nextDropdown} from "../../../../../../actions/dropdown";
import { DropdownMenu } from "../../../../../Shared/DropdownMenu/DropdownMenu";
import { getLocaleString } from "../../../../../../../../pbcloud-reader/src/locale";
import { Scrollbars } from 'react-custom-scrollbars';
import { setSearchResult } from '../../../../../../actions/reader'

const DROPDOWN_ID = 'SEARCH'
const isActive = equals(DROPDOWN_ID)

const toggleMenu = ({activeDropdown, nextDropdown}) => ({isInner = false}) => ifElse(
  equals(true),
  () => nextDropdown(null),
  () => ifElse(
    equals(false),
    () => nextDropdown(DROPDOWN_ID),
    always(null)
  )(isInner)
)(isActive(activeDropdown))

const state = {
  inputRef: {},
  searchVal: ''
}

const stateHandlers = {
  setSeachRef: () => (ref) => ({
    inputRef: ref
  }),
  onOpenSearch: ({inputRef}) => (onSearch) => {
    setTimeout(() => {
      inputRef.focus()
      let text = inputRef.value
      if (text.length > 0) {
        onSearch(false, inputRef.value)
      }
    }, 500)
  },
  onCloseSearch: ({inputRef}) => (saved = false) => {
    if (!saved) inputRef.value = ''
  }
}

const mapStateToProps = state => ({
  activeDropdown: state.activeDropdown,
  searchResult: state.reader.searchResult
})

const mapDispatchToProps = (dispatch) => ({
  nextDropdown: (id) => dispatch(nextDropdown(id)),
  setSearchResult: (result) => dispatch(setSearchResult(result))
})

const handlers = withHandlers({
  toggleMenu
})

export const enhance = compose(
  setDisplayName('Search'),
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(['activeDropdown'], ({activeDropdown}) => ({
    active: isActive(activeDropdown)
  })),
  handlers,
  withStateHandlers(state, stateHandlers)
)

const SearchForm = ({setSeachRef, onCloseSearch, toggleMenu, onSearch, searchResult, onChangePage,
                      setSearchResult }) => (
  <div className="Search__form" onClick={e => e.preventDefault()}>
    <input id="Search__field" ref={(ref) => setSeachRef(ref)} onChange={(e) => onSearch(e)}/>
    <button className="clear-search icon-btn" onClick={() => {setSearchResult([]);onCloseSearch();toggleMenu(false);onSearch(false, '')}}></button>
    <SearchResult searchResult={searchResult} onChangePage={onChangePage} toggleMenu={toggleMenu}/>
  </div>
)

const getHeight = (searchResult) => {
  if (searchResult.length > 0 && searchResult[0].notFound) {
    return 60
  } else {
    return 360
  }
}

const SearchResult = ({searchResult, onChangePage, toggleMenu}) => (
  <div className={`Search__result limit-content-height${searchResult.length > 0 ? ' show' : ''}${searchResult.length > 0 && searchResult[0].notFound ? ' notFound' : ''}`}>
    <Scrollbars style={{ width: 355, height: getHeight(searchResult) }}
                renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{display:"none"}}/>}
    >
      <ul>
        { searchResult.length > 0 && searchResult[0].notFound ?
          <NotFound />
          : searchResult.length > 0 ? searchResult.map((item, index) => <SearchResultItem key={index} item={item} onChangePage={onChangePage} toggleMenu={toggleMenu}/>)
          : ''
        }
      </ul>
    </Scrollbars>
    {searchResult.length > 0 && !searchResult[0].notFound ? <span className="Search__result_stats">{getLocaleString('reader.found')} {searchResult.length} {searchResult.length === 1 ?
      getLocaleString('reader.searchResult') : searchResult.length < 5 ? getLocaleString('reader.searchResultsThanFive') : getLocaleString('reader.searchResults')}</span>
      : ''}
  </div>
)

const NotFound = () => (
  <li className="Result notFound">
    <span className="Result__chapter__name">{getLocaleString('reader.notFound')}</span>
  </li>
)

const SearchResultItem = ({item, onChangePage, toggleMenu}) => (
  <li className="Result" onClick={() => {onChangePage(item.range); toggleMenu(false)}}>
    <span className="Result__chapter__name">{item.chapterTitle}</span>
    <div className="Result__content">
      <span className="Result__text">{item.text}</span>
      <span className="Result__page">{item.page}</span>
    </div>
  </li>
)

const View = ({toggleMenu, active, setSeachRef, onOpenSearch, onCloseSearch, onSearch, searchResult,
                onChangePage, setSearchResult }) => (
  <div className="Search">
    <button className={`search-btn icon-btn${active ? ' hide' : '' }`} onClick={() => {onCloseSearch(true);toggleMenu(false);onOpenSearch(onSearch)}} data-active={active}></button>
    <DropdownMenu active={active}>
      <SearchForm setSeachRef={setSeachRef} onCloseSearch={onCloseSearch} toggleMenu={toggleMenu} onSearch={onSearch}
                  searchResult={searchResult} onChangePage={onChangePage} setSearchResult={setSearchResult}/>
    </DropdownMenu>
  </div>
)

export const Search = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/components/Search/Search.js